import React from 'react';
import PropTypes from 'prop-types';

import BrStepLabel from './BrStepLabel';

/* eslint-disable react/no-array-index-key */
export default function BrVerticalStepper(props) {
  const { workflowSteps, activeStepIndex, nestingLevel } = props;

  return workflowSteps.map((stepDetail, i) => {
    const hasSubSteps = !!stepDetail.subSteps;
    if (hasSubSteps) {
      return (
        <div key={i}>
          <BrStepLabel
            label={stepDetail.label}
            active={activeStepIndex === i}
            nestingLevel={nestingLevel}
            stepNumber={i + 1}
            totalSteps={workflowSteps.length}
            hasSubSteps={hasSubSteps}
          />
          <div>
            <BrVerticalStepper
              workflowSteps={stepDetail.subSteps.workflowSteps}
              activeStepIndex={stepDetail.subSteps.activeStepIndex}
              nestingLevel={nestingLevel + 1}
            />
          </div>
        </div>
      );
    }
    return (
      <BrStepLabel
        label={stepDetail.label}
        active={activeStepIndex === i}
        nestingLevel={nestingLevel}
        key={i}
        stepNumber={nestingLevel === 1 ? i + 1 : undefined}
        totalSteps={workflowSteps.length}
        hasSubSteps={hasSubSteps}
      />
    );
  });
}

BrVerticalStepper.propTypes = {
  workflowSteps: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeStepIndex: PropTypes.number,
  nestingLevel: PropTypes.oneOf([1, 2]),
};
